import { render, staticRenderFns } from "./EmailsPreview.vue?vue&type=template&id=52779ad8"
import script from "./EmailsPreview.vue?vue&type=script&lang=js"
export * from "./EmailsPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports